
export default {
  props: {
    gridElements: Array,
  },
};
